import { connect } from 'react-redux'
import { AppState } from 'store/types'
import { SlotId } from 'services/adition'
import { getContentUnitId, areAdsDisabledByEnv } from 'config/adSlots'
import { areAdsDisabled } from 'store/modules/session/selectors'
import AdSlot from './AdSlot'

const mapStateToProps = ({ session }: AppState, { slotId }: { slotId: SlotId }) => {
  const contentUnitId = Number(getContentUnitId(slotId))

  return {
    contentUnitId,
    show: !!(contentUnitId && !areAdsDisabled(session) && !areAdsDisabledByEnv()),
  }
}

export default connect(mapStateToProps)(AdSlot)
try {
    // @ts-ignore
    AdSlotContainer.displayName = "AdSlotContainer";
    // @ts-ignore
    AdSlotContainer.__docgenInfo = { "description": "", "displayName": "AdSlotContainer", "props": { "slotId": { "defaultValue": null, "description": "", "name": "slotId", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/AdSlot/AdSlotContainer.tsx#AdSlotContainer"] = { docgenInfo: AdSlotContainer.__docgenInfo, name: "AdSlotContainer", path: "src/components/AdSlot/AdSlotContainer.tsx#AdSlotContainer" };
}
catch (__react_docgen_typescript_loader_error) { }